export default "__VITE_ASSET__1e438bf1__"